import React from 'react';
import {
  AppBar,
  AppBarDataCustomItem,
  Button,
  ScrollableViewport,
} from '@ihsm/ui-shared';
import { PageContent } from 'shared/components/PageContent';
import { TransparentButton } from 'shared/components/Buttons';
import { useMetricsForm } from 'scenes/metrics/hooks/useMetricsForm';
import { NewMetricsForm } from 'scenes/metrics/components/NewMetricsForm';
import { HeaderButtonWrapper } from 'shared/components/HeaderButtonWrapper';
import { InnerPagePadding } from 'shared/components/InnerPagePadding';
import { SearchTreeMetrics } from '../components/SearchTreeMetrics';

export const NewMetrics: React.FC = (): JSX.Element => {
  const { form, setForm, onSave, onCancel } = useMetricsForm();

  const cancelButton: AppBarDataCustomItem = {
    type: 'customOption',
    component: (
      <HeaderButtonWrapper>
        <TransparentButton text="Cancel" onClick={onCancel} />
      </HeaderButtonWrapper>
    ),
  };

  const saveButton: AppBarDataCustomItem = {
    type: 'customOption',
    component: (
      <HeaderButtonWrapper>
        <Button text="Save" onClick={onSave} />
      </HeaderButtonWrapper>
    ),
  };

  return (
    <PageContent
      searchTree={<SearchTreeMetrics disableAddButton />}
      headerControls={
        <AppBar menuItems={[cancelButton, saveButton]}>New Metric</AppBar>
      }
    >
      <ScrollableViewport vertical>
        <InnerPagePadding>
          <NewMetricsForm form={form} setForm={setForm} />
        </InnerPagePadding>
      </ScrollableViewport>
    </PageContent>
  );
};
